<!--


-->
<template>
	<div class="sub-nav__catalog-search">
			<input type="text" v-model="keyword" v-on:keyup.enter="search" placeholder="商品検索">
      <button type="button" v-on:click="search"><i class="fas fa-search"></i></button>
	</div>
</template>

<script>
  export default {
    data: function () {
      return {
        keyword: ""
      }
    },
    methods: {
      search: function () {
        this.$router.push({name: "search", params: {Keyword: this.keyword}});      
      }
    }
  }  
</script>
